import { ReactNode } from 'react'
import { TouchableOpacity, StyleSheet, GestureResponderEvent } from 'react-native'
import { DS } from '../../../design-system'

// Note: `children` appear to the right of the menu text, useful for icons
// Not correct for LTR languages
type DrawerItemProps = {
  text: string
  onPress?: (e: GestureResponderEvent) => void
  secondary?: boolean
  bold?: boolean
  children?: ReactNode
}

export const DrawerItem = ({ onPress, text, secondary, bold, children }: DrawerItemProps) => {
  const weight = bold ? 'Medium' : 'Regular'
  return (
    <TouchableOpacity style={styles.container} onPress={onPress}>
      <DS.Text
        variant={secondary ? `Body Small/${weight}` : `Body Medium/${weight}`}
        allowFontScaling={false}
        textBreakStrategy={'simple'}
        style={styles.text}
      >
        {text}
      </DS.Text>
      {children}
    </TouchableOpacity>
  )
}

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: DS.spacing[4]
  },
  text: {
    paddingLeft: DS.spacing[16]
  }
})
